import apiClient from './client';

export const PolicyAxiosInstance = apiClient;